export default __webpack_public_path__ + "static/media/close.ed61d15e.svg";